import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { cityModification, getSingleCity } from "./cityAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate, Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';

import { getAllCity } from "./cityAction";
import { FaArrowLeft } from 'react-icons/fa';



const initialState = {
  id: "",
  city: "",
  status: "",

}



const ModifyCity = () => {
  let navigate = useNavigate();
    const {id}=useParams();
  //  console.log('modify'+id);
    const { cityisLoading, citymstatus, citymmessage } = useSelector((state) => state.citiesList);

    const dispatch = useDispatch();
    
    const [cities, setCities] = useState({
      id:"",
      city:"",
      status:""
    });
    
   
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);
  
    
    const cityData = useSelector((state) => state.citiesList);
    


    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadCity(id);
      return;
    }

   // console.log("componentDidUpdateFunction");
  });
   useEffect(() => { 
   
    loadCity(id);
    setCities({id:id,city:"",status:""});
     }, []);

     useEffect(() => {
      dispatch(getAllCity());
     
  }, [dispatch,citymmessage]);
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadCity(id){
      dispatch(getSingleCity(id));
      setCities({id:id,city:uData.city_name,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(cityData.cities));
  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
   
    setCities({ ...cities, [name]: value });
    
  };

  
  const handleOnSubmit = (e) => {
    e.preventDefault();
    Swal.fire('City updated Successfully!', '', 'success')
   
    const { id, city, status
    } = cities;

    if (city === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/cityList');
      return;
    }

    const cityUpdation1 = {
      id,
      city,
      status
    };
   
    dispatch(cityModification(cityUpdation1));
    setModify(1);
    navigate('/cityList');
   
  
  };


 
  return (
    <>
     
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify City</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/cityList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="city" value={cities.city ? cities.city : uData.city_name} autoComplete='off' placeholder="Enter City" {...register("city", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                 {errors.city && <p className='text-danger'> City Name required</p>}
                </Form.Group>
               
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={cities.status ? cities.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
                Submit
              </Button>
              </div>
              {cityisLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default ModifyCity;